export default __webpack_public_path__ + "static/media/logInImage.4f6dd4bb.png";